export default __webpack_public_path__ + "static/la-playa-vol-3-homepage-anner-desktop-w2-f19d3b3f5607e702fc249e3bb2d8a86c.webp";